/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CallNotification } from '../models/call-notification';
import { CallNotificationList } from '../models/call-notification-list';
import { CallNotificationPagedList } from '../models/call-notification-paged-list';
import { create } from '../fn/call-notification/create';
import { Create$Params } from '../fn/call-notification/create';
import { exportCallNotifications } from '../fn/call-notification/export-call-notifications';
import { ExportCallNotifications$Params } from '../fn/call-notification/export-call-notifications';
import { getCallNotification } from '../fn/call-notification/get-call-notification';
import { GetCallNotification$Params } from '../fn/call-notification/get-call-notification';
import { getCallNotificationsByIntervenantCode } from '../fn/call-notification/get-call-notifications-by-intervenant-code';
import { GetCallNotificationsByIntervenantCode$Params } from '../fn/call-notification/get-call-notifications-by-intervenant-code';
import { searchCallNotifications } from '../fn/call-notification/search-call-notifications';
import { searchCallNotifications$Any } from '../fn/call-notification/search-call-notifications-any';
import { SearchCallNotifications$Any$Params } from '../fn/call-notification/search-call-notifications-any';
import { SearchCallNotifications$Params } from '../fn/call-notification/search-call-notifications';


/**
 * All about the call notification the system can receive
 */
@Injectable({ providedIn: 'root' })
export class CallNotificationService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `create()` */
  static readonly CreatePath = '/notification/call';

  /**
   * Create.
   *
   * Create a call notification
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params: Create$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return create(this.http, this.rootUrl, params, context);
  }

  /**
   * Create.
   *
   * Create a call notification
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params: Create$Params, context?: HttpContext): Observable<void> {
    return this.create$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `searchCallNotifications()` */
  static readonly SearchCallNotificationsPath = '/notification/call/search';

  /**
   * search call notifications.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchCallNotifications()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchCallNotifications$Response(params?: SearchCallNotifications$Params, context?: HttpContext): Observable<StrictHttpResponse<CallNotificationPagedList>> {
    return searchCallNotifications(this.http, this.rootUrl, params, context);
  }

  /**
   * search call notifications.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchCallNotifications$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchCallNotifications(params?: SearchCallNotifications$Params, context?: HttpContext): Observable<CallNotificationPagedList> {
    return this.searchCallNotifications$Response(params, context).pipe(
      map((r: StrictHttpResponse<CallNotificationPagedList>): CallNotificationPagedList => r.body)
    );
  }

  /**
   * search call notifications.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchCallNotifications$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchCallNotifications$Any$Response(params?: SearchCallNotifications$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<CallNotificationPagedList>> {
    return searchCallNotifications$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * search call notifications.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchCallNotifications$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchCallNotifications$Any(params?: SearchCallNotifications$Any$Params, context?: HttpContext): Observable<CallNotificationPagedList> {
    return this.searchCallNotifications$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<CallNotificationPagedList>): CallNotificationPagedList => r.body)
    );
  }

  /** Path part for operation `exportCallNotifications()` */
  static readonly ExportCallNotificationsPath = '/notification/call/export';

  /**
   * Export call notifications.
   *
   * Allows to export all the call notifications as an XLSX File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportCallNotifications()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportCallNotifications$Response(params?: ExportCallNotifications$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportCallNotifications(this.http, this.rootUrl, params, context);
  }

  /**
   * Export call notifications.
   *
   * Allows to export all the call notifications as an XLSX File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportCallNotifications$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportCallNotifications(params?: ExportCallNotifications$Params, context?: HttpContext): Observable<Blob> {
    return this.exportCallNotifications$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `getCallNotification()` */
  static readonly GetCallNotificationPath = '/notification/call/{uid}';

  /**
   * Get a call notification.
   *
   * Get a call notification
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCallNotification()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCallNotification$Response(params: GetCallNotification$Params, context?: HttpContext): Observable<StrictHttpResponse<CallNotification>> {
    return getCallNotification(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a call notification.
   *
   * Get a call notification
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCallNotification$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCallNotification(params: GetCallNotification$Params, context?: HttpContext): Observable<CallNotification> {
    return this.getCallNotification$Response(params, context).pipe(
      map((r: StrictHttpResponse<CallNotification>): CallNotification => r.body)
    );
  }

  /** Path part for operation `getCallNotificationsByIntervenantCode()` */
  static readonly GetCallNotificationsByIntervenantCodePath = '/notification/call/byIntervenantCode/{code}';

  /**
   * Get a list of call notification by intervenant code.
   *
   * Get a list of call notification by intervenant code
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCallNotificationsByIntervenantCode()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCallNotificationsByIntervenantCode$Response(params: GetCallNotificationsByIntervenantCode$Params, context?: HttpContext): Observable<StrictHttpResponse<CallNotificationList>> {
    return getCallNotificationsByIntervenantCode(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a list of call notification by intervenant code.
   *
   * Get a list of call notification by intervenant code
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCallNotificationsByIntervenantCode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCallNotificationsByIntervenantCode(params: GetCallNotificationsByIntervenantCode$Params, context?: HttpContext): Observable<CallNotificationList> {
    return this.getCallNotificationsByIntervenantCode$Response(params, context).pipe(
      map((r: StrictHttpResponse<CallNotificationList>): CallNotificationList => r.body)
    );
  }

}
